module.exports = __webpack_public_path__ + "static/illustration-of-no-interest-a88cac94122b2d04f7e92272a9dddeae.png";